import ErrorHandler from './error.handler'
import AuthResultHandler from './authresult.handler'
import MessageHandler from './message.handler'
import { CustomerTrafficHandler } from './customertraffic.handler'
import { MachineOtaProgressHandler } from './machine-ota-progress.handler'
import { MachineOtaWriteErrorHandler } from './machine-ota-write-error.handler'
import ChannelCalibrationStatusHandler from './channel-calibration-status.handler'
import { QuickSupportHandler } from './quick-support.handler'
import VolumeMeasureStatusHandler from './volume-measure-status.handler'
import LiveLogNotificationHandler from './live-log-notification.handler'
import NotificationChangedHandler from './notification-changed.handler'

const handlers = [ErrorHandler, AuthResultHandler, MessageHandler, CustomerTrafficHandler, MachineOtaProgressHandler, MachineOtaWriteErrorHandler, ChannelCalibrationStatusHandler, QuickSupportHandler, VolumeMeasureStatusHandler, LiveLogNotificationHandler, NotificationChangedHandler]
export default handlers
